import { Plus } from "lucide-react";
import { useState } from "react";
import ReactPaginate from "react-paginate";

const itemsPerPage = 3;

export default function MainVolunteerMatch() {
  const [isSelect, setIsSelect] = useState("Cooking");
  const [currentPage, setCurrentPage] = useState(0);

  const data = [
    {
      id: 1,
      name: "Cooking",
      icon: "/assets/images/volunteer/cook.svg",
    },
    {
      id: 2,
      name: "Medical Aid",
      icon: "/assets/images/volunteer/medical.svg",
    },
    {
      id: 3,
      name: "Logistics",
      icon: "/assets/images/volunteer/logistics.svg",
    },
    {
      id: 4,
      name: "Teaching",
      icon: "/assets/images/volunteer/teaching.svg",
    },
  ];

  const volunteer = [
    {
      id: 1,
      name: "Janis",
      desc: "Food Packing, Event Coordination · Weekends, Evening · Fort Worth, 76104",
      match: "92",
    },
    {
      id: 2,
      name: "Janis",
      desc: "Food Packing, Event Coordination · Weekends, Evening · Fort Worth, 76104",
      match: "92",
    },
    {
      id: 3,
      name: "Janis",
      desc: "Food Packing, Event Coordination · Weekends, Evening · Fort Worth, 76104",
      match: "92",
    },
    {
      id: 4,
      name: "Janis",
      desc: "Food Packing, Event Coordination · Weekends, Evening · Fort Worth, 76104",
      match: "92",
    },
    {
      id: 5,
      name: "Janis",
      desc: "Food Packing, Event Coordination · Weekends, Evening · Fort Worth, 76104",
      match: "92",
    },
    {
      id: 6,
      name: "Janis",
      desc: "Food Packing, Event Coordination · Weekends, Evening · Fort Worth, 76104",
      match: "92",
    },
    {
      id: 7,
      name: "Janis",
      desc: "Food Packing, Event Coordination · Weekends, Evening · Fort Worth, 76104",
      match: "92",
    },
    {
      id: 8,
      name: "Janis",
      desc: "Food Packing, Event Coordination · Weekends, Evening · Fort Worth, 76104",
      match: "92",
    },
    {
      id: 9,
      name: "Janis",
      desc: "Food Packing, Event Coordination · Weekends, Evening · Fort Worth, 76104",
      match: "92",
    },
    {
      id: 10,
      name: "Janis",
      desc: "Food Packing, Event Coordination · Weekends, Evening · Fort Worth, 76104",
      match: "92",
    },
    {
      id: 11,
      name: "Janis",
      desc: "Food Packing, Event Coordination · Weekends, Evening · Fort Worth, 76104",
      match: "92",
    },
    {
      id: 12,
      name: "Janis",
      desc: "Food Packing, Event Coordination · Weekends, Evening · Fort Worth, 76104",
      match: "92",
    },
    {
      id: 13,
      name: "Janis",
      desc: "Food Packing, Event Coordination · Weekends, Evening · Fort Worth, 76104",
      match: "92",
    },
    {
      id: 14,
      name: "Janis",
      desc: "Food Packing, Event Coordination · Weekends, Evening · Fort Worth, 76104",
      match: "92",
    },
    {
      id: 15,
      name: "Janis",
      desc: "Food Packing, Event Coordination · Weekends, Evening · Fort Worth, 76104",
      match: "92",
    },
  ];

  const offset = currentPage * itemsPerPage;
  const currentItems = volunteer.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(volunteer.length / itemsPerPage);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  return (
    <div className="mb-6 lg:w-[85%]">
      <div>
        <div className="flex items-center gap-x-1 -ml-[6px]">
          <h1 className="font-popinsBold text-xl lg:text-2xl">
            Volunteer Matching
          </h1>
        </div>
        <p className="font-popinsRegular text-sm text-black/50 mt-2">
          Find the right volunteers for your events and services.
        </p>
      </div>
      <div className="flex flex-wrap gap-3 mt-8">
        {data.map((item) => (
          <div
            className={`flex items-center gap-x-2 rounded-lg py-[10px] px-4 cursor-pointer ${
              isSelect === item.name ? "bg-themeColor" : "bg-[#CCCCCC]"
            }`}
            onClick={() => setIsSelect(item.name)}
          >
            <img src={item.icon} alt="" className="size-5" />
            <p className="font-popinsMedium text-sm">{item.name}</p>
          </div>
        ))}
      </div>
      <div className="lg:w-[55%] mt-5">
        <select class="w-full mt-2 font-popinsMedium rounded-md border-2 border-border bg-white px-4 py-3 text-black/50 outline-none transition-all duration-300 ease-in-out focus:border-[#3FC4E3] focus:shadow-[0_0_3px_#3FC4E3] appearance-none cursor-pointer">
          <option value="" disabled selected>
            Availability
          </option>
          <option value="commercial">Commercial</option>
          <option value="residential">Residential</option>
        </select>
        <input
          type="text"
          placeholder="City or ZIP search"
          class="w-full mt-5 font-popinsMedium rounded-md border-2 border-border bg-white px-4 py-3 text-black/50 outline-none transition-all duration-300 ease-in-out focus:border-[#3FC4E3] focus:shadow-[0_0_3px_#3FC4E3]"
        />
      </div>
      <div className="flex justify-end mt-3">
        <button
          className="relative overflow-hidden py-3 bg-themeColor text-white font-popinsSemiBold text-base mt-5 rounded-md shadow-lg
                   transform transition duration-300 ease-in-out
                   hover:bg-[#3FC4E3] hover:scale-105 hover:shadow-[0_0_20px_rgba(63,196,227,0.6)] 
                   active:scale-95 active:shadow-inner focus:outline-none flex items-center px-5 gap-x-2"
        >
          <span className="bg-white p-1 rounded-md">
            <Plus size={14} className="text-themeColor" />
          </span>
          <span>Apply Filter</span>
          <span className="absolute inset-0 rounded-full bg-white opacity-0 active:opacity-10 transition-opacity duration-300"></span>
        </button>
      </div>
      <div className="mt-10 lg:mt-6">
        <h3 className="font-popinsSemiBold text-xl mb-6">
          Suggested Volunteers
        </h3>
        {currentItems.map((item) => (
          <div className="flex flex-col-reverse lg:flex-row mt-8">
            <div className="w-full lg:w-[70%] mt-4 lg:mt-0">
              <p className="font-popinsRegular text-sm text-black/50">
                {item.match}% match
              </p>
              <p className="font-popinsSemiBold text-base">{item.name}</p>
              <p className="font-popinsRegular text-sm text-black/50">
                {item.desc}
              </p>
              <button
                className="relative overflow-hidden py-3 bg-themeColor text-white font-popinsSemiBold text-sm mt-5 rounded-md shadow-lg
                   transform transition duration-300 ease-in-out
                   hover:bg-[#3FC4E3] hover:scale-105 hover:shadow-[0_0_20px_rgba(63,196,227,0.6)] 
                   active:scale-95 active:shadow-inner focus:outline-none flex items-center px-5 gap-x-2"
              >
                <img
                  src="/assets/images/volunteer/user.svg"
                  alt=""
                  className="size-5"
                />
                <span>Invite To Event</span>
                <span className="absolute inset-0 rounded-full bg-white opacity-0 active:opacity-10 transition-opacity duration-300"></span>
              </button>
            </div>
            <div className="w-full lg:w-[30%]">
              <img
                src="/assets/images/volunteer/volunteer.jpg"
                alt=""
                className="w-full h-[160px] rounded-lg object-cover"
              />
            </div>
          </div>
        ))}
        {/* Pagination */}
        <div className="flex justify-center border-t py-6 border-gray-200 font-popinsMedium">
          <ReactPaginate
            previousLabel={"<"}
            nextLabel={">"}
            breakLabel={"..."}
            onPageChange={handlePageClick}
            pageCount={pageCount}
            containerClassName="flex space-x-2"
            pageClassName="px-3 py-1 border rounded-md cursor-pointer"
            activeClassName="bg-themeColor text-white"
            previousClassName="px-3 py-1 border rounded-md cursor-pointer"
            nextClassName="px-3 py-1 border rounded-md cursor-pointer"
            disabledClassName="opacity-50 cursor-not-allowed"
          />
        </div>
      </div>
    </div>
  );
}
